import { createTheme } from '@mui/material'
import { ThemeProvider } from '@emotion/react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './Pages/Home';
import About from './Pages/About';
import Terms from './Pages/Terms';
import Privacy from './Pages/Privacy';
import Booking from './Pages/Booking';
import Apply from './Pages/Apply';
import ApplyNow from './Pages/Applynow';
import CreditCard from './Pages/CreditCard';
import Tradeline from './Pages/Tradeline';
import CreditRepair from './Pages/CreditRepair';


function App() {

  const theme = createTheme({
    palette: {
      primary: {
        main: '#4A3FFF'
      },
      secondary: {
        main: '#7badf9'
      }
    },

    typography: {
      fontFamily: "Fustat-Medium",
      fontWeightLight: 300,
      fontWeightRegular: 400,
      fontWeightBold: 800,
      fontSize: 20
    }
  })

  return (
    <ThemeProvider theme={theme}>
      <Router>
        <Routes>
          <Route exact path='/' element={<Home title={"Welcome | Fund Genies"} />} />
          <Route exact path='/about' element={<About title={"About Us | Fund Genies"} />} />
          <Route exact path='/terms' element={<Terms title={"Terms | Fund Genies"} />} />
          <Route exact path='/privacy' element={<Privacy title={"Privacy Policiy | Fund Genies"} />} />
          <Route exact path='/book' element={<Booking title={"Fund Genies"} />} />
          <Route exact path='/apply' element={<Apply title={"Fund Genies"} />} />
          <Route exact path='/applynow' element={<ApplyNow title={"Fund Genies"} />} />
          <Route exact path='/creditcard' element={<CreditCard title={"Fund Genies"} />} />
          <Route exact path='/personaloan' element={<Tradeline title={"Fund Genies"} />} />
          <Route exact path='/creditrepair' element={<CreditRepair title={"Fund Genies"} />} />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;
